import { assign } from 'lodash';
import { WorkItemTypeValue } from 'common/workitems/constants/workitem-types';
import { DynamicQueryEvent } from 'common/dynamicquery/dynamic-query-events.factory';

export class Workitem {
  public ItemType;

  static comparator(workitem1, workitem2) {
    return workitem1.WorkItemID === workitem2.WorkItemID;
  }

  static wrap(event: Partial<DynamicQueryEvent>): Workitem {
    return new Workitem(event.data);
  }

  constructor(workitem) {
    assign(this, workitem);
  }

  isChatType() {
    return this.ItemType === WorkItemTypeValue.CHAT;
  }

  isEmailType() {
    return this.ItemType === WorkItemTypeValue.EMAIL;
  }

  isSmsType() {
    return this.ItemType === WorkItemTypeValue.SMS;
  }

  isLensType() {
    return this.ItemType === WorkItemTypeValue.LENS;
  }

  isFacebookType() {
    return this.ItemType === WorkItemTypeValue.FACEBOOK;
  }

  isAsyncMessageType() {
    return this.ItemType === WorkItemTypeValue.ASYNC_MESSAGE;
  }

  isMessageType() {
    return this.isSmsType() || this.isFacebookType() || this.isAsyncMessageType();
  }
}

export function factory() {
  return Workitem;
}
